import {ReactElement} from "react";
import {useTranslation} from "react-i18next";
import {WZItem} from "./types";

type ItemsTableProps = {
    items: WZItem[];
};

export function ItemsTable({items}: ItemsTableProps): ReactElement {
    const {t} = useTranslation();

    return (
        <table className="table-data wz-items-table">
            <thead>
                <tr>
                    <th>{t('user-page.wz.item-lp')}</th>
                    <th>{t('user-page.wz.item-name')}</th>
                    <th>{t('user-page.wz.item-index')}</th>
                    <th>{t('user-page.wz.item-ean')}</th>
                    <th>{t('user-page.wz.item-quantity')}</th>
                    <th>{t('user-page.wz.item-unit')}</th>
                </tr>
            </thead>
            <tbody>
                {items.map((item, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.productName}</td>
                        <td>{item.product.hurtId}</td>
                        <td>{item.product.ean}</td>
                        <td>{item.quantity}</td>
                        <td>{item.product.unit}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
